//SHOW HIDE WINDOW SIZE GUIDE
head.ready("appJS", function() {
  $(document).ready(function() {
		if(angelCake.getUrlVars()['showguide']=='true'){
			angelCake.setCookie('showguide','true',999);
		}
		if(angelCake.getUrlVars()['showguide']=='false'){
			angelCake.deleteCookie('showguide');
		}
		if(angelCake.getCookie('showguide')=='true'){
			$('body').append('<div id="angelcake-showguide"><div class="xs">xs</div><div class="sm">sm</div><div class="md">md</div><div class="lg">lg</div><div class="xl">xl</div></div>');
		}
		//END SHOW HIDE WINDOW SIZE GUIDE

	});
	});